import { MenuItem, Select } from "@mui/material";
import React, { useContext } from "react";
import { PosContext } from "../shared/PosContext";
import {
    useUpdateuserDefaults
} from "../shared/hooks/useUser";

const SimpleFloorRooms = () => {
    const { roomOptions, roomContext, refetchDefaultRoom } = useContext(PosContext);
    const [selectedRoom, setSelectedRoom] = roomContext;

    const updateuserDefaultsMutation = useUpdateuserDefaults();

    const handleRoomChange = (e) => {
        const nextRoom = e?.target?.value;
        if (nextRoom) {
            setSelectedRoom(nextRoom);
            updateuserDefaultsMutation.mutate(
                {
                    key: "Room",
                    value: nextRoom.name,
                },
                {
                    onSuccess: () => {
                        refetchDefaultRoom();
                    },
                }
            );
        }
    };

    const roomKeys = roomOptions ? Object.keys(roomOptions) : [];
    const roomCount = roomKeys.length;

    return (
        <React.Fragment>
            {roomOptions && (
                <>
                    {roomCount === 1 ? (
                        <></>
                    ) : (
                        <Select
                            labelId="rooms-select-standard-label"
                            value={selectedRoom || []}
                            variant="standard"
                            onChange={handleRoomChange}
                            label={"Room"}
                        >
                            {roomKeys.map((room, index) => (
                                <MenuItem
                                    value={roomOptions[room]}
                                    key={"Room_Item_" + index}
                                >
                                    {room}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                </>
            )}
        </React.Fragment>
    );
};

export default SimpleFloorRooms;
